import type { ErrorSnackbarContext } from "_shared/_errors/error-snackbar";

/**
 * What a failed download of a message's file tells the person who asked for it.
 *
 * A refusal says why. The server names a file still being scanned, found infected, or not scanned
 * (`FileWithheldRefusal`), and a file whose subject matter the reader holds no grant for
 * (`AttachmentSubjectMatterRefusal`, #6993). The person reads that sentence rather than "try again",
 * which never changes a refusal (#6876). A refusal that gives no reason of its own is about access to the
 * conversation or to the comment the file is on.
 */
export const ATTACHMENT_DOWNLOAD_FAILURE: ErrorSnackbarContext = {
  doing: "downloading the file",
  operation: "messaging.attachment.download",
  refusedMessage: "You don't have access to the conversation or comment this file is on, so you can't download it.",
};
